import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { Kpimaster } from 'src/app/models/commission/kpimaster.model';
import { MissingDisputesModel } from 'src/app/models/commission/missingdisputes.model';
import { WorkFlowMessageModel } from 'src/app/models/commissionsummary/workflowmessage.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { CommissionSummaryService } from 'src/app/service/commission-summary.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { KpimasterService } from 'src/app/service/kpimaster.service';
import { LoggerService } from 'src/app/service/logger.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { MissingDisputesService } from 'src/app/service/missingdisputes.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-missing-disputes',
  templateUrl: './missing-disputes.component.html',
  styleUrls: ['./missing-disputes.component.css']
})
export class MissingDisputesComponent implements OnInit {

  public missingDisputesModel = new MissingDisputesModel();
  public missingDisputesModel1 = new MissingDisputesModel();
  public workFlowMessageModel = new WorkFlowMessageModel();

  public missingDisputesList: MissingDisputesModel[];
  public missingModels: MissingDisputesModel[] = [];

  public isAccessDisabled: boolean = false;
  public showLoading: boolean;
  public ordersTableColumns1: TableColumn[];
  public columnsData: any;
  public actions: any;
  public actionButtons: any;
  public disputeMsg: string;
  public userData: AddUser[] = [];
  public comPlansUserData: AddUser[] = [];
  public kpis: MissingDisputesModel[];
  public kpisData: MissingDisputesModel[] = [];
  public filterKPiData: MissingDisputesModel[] = [];
  public vkpiid: string = "";

  constructor(private globalService: GlobalService, private router: Router, private logger: LoggerService,
    private httpService: HttpClient, private notificationService: NotificationService, private route: ActivatedRoute,
    public ete: ExportExcelService, private authgurdService: AuthGaurdService, private missingDisputesService: MissingDisputesService,
    private commissionSummaryService: CommissionSummaryService, private manageUserService: ManageUserService, private kpimasterService: KpimasterService) {
    globalService._disableBackButton();
  }

  ngOnInit(): void {
    this.isAccessDisabled = this.globalService._permissionCheck('missing-disputes');

    this.missingDisputesModel.created_by = "";
    this.missingDisputesModel.created_dt = new Date();
    this.missingModels.push(this.missingDisputesModel);

    this.getMissingDisputes();
    this.initializeColumns();
    this.getCommissionPlans();

  }

  public getActiveKpis(commPlanValue: number): void {
    console.log(commPlanValue);
    this.missingDisputesService.getKpiList(commPlanValue).subscribe(
      (response: MissingDisputesModel[]) => {
        this.kpis = response;
        console.log(this.kpis);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  getCommissionPlans() {
    this.manageUserService.getPrePopulatedUserData().subscribe((data: any) => {
      this.logger.info(data);
      this.userData = data;
      console.log(this.userData);
      for (let userInfo of this.userData) {
        if (userInfo.commission_plan != null) {
          this.comPlansUserData.push(userInfo);
        }
      }

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  getCommPlan($event, commPlanValue) {
    this.missingDisputesModel.comm_plan_id = commPlanValue;
    console.log(this.missingDisputesModel.comm_plan_id);
    this.getActiveKpis(commPlanValue);
  }

  public getMissingDisputes(): void {
    this.missingDisputesService.getMissingDisputesList().subscribe(
      (response: MissingDisputesModel[]) => {
        this.missingDisputesList = response;
        console.log(this.missingDisputesList);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public insertMissingDispute(kpiForm: NgForm): void {

    for (let val of this.missingModels) {
      this.vkpiid = this.vkpiid + val.kpi_id + ",";
    }
    this.vkpiid = this.vkpiid.replace(/,\s*$/, "");
    kpiForm.value.kpi_id = this.vkpiid;
    kpiForm.value.comm_plan_id = this.missingDisputesModel.comm_plan_id;
    kpiForm.value.cust_id = this.missingDisputesModel.cust_id;
    kpiForm.value.corp = this.missingDisputesModel.corp;
    kpiForm.value.house = this.missingDisputesModel.house;
    kpiForm.value.revenue = this.missingDisputesModel.revenue;
    kpiForm.value.wordate = this.missingDisputesModel.wordate;
    kpiForm.value.wfindate = this.missingDisputesModel.wfindate;
    kpiForm.value.message = this.missingDisputesModel.message;
    kpiForm.value.sales_rep_id = this.missingDisputesModel.sales_rep_id;

    console.log("formData = " + JSON.stringify(kpiForm.value));
    this.showLoading = true;
    const formData = this.missingDisputesService.createForm(kpiForm.value);
    console.log("formData = " + JSON.stringify(formData));

    this.disputeMsg = "<Corp>" + this.missingDisputesModel.corp + "</Corp>"
      + "<House>" + this.missingDisputesModel.house + "</House>" + "<CustomerName>" + this.missingDisputesModel.cust_id + "</CustomerName>" + "<CompasID>001</CompasID>"
      + "<Revenue>" + this.missingDisputesModel.revenue + "</Revenue>" + "<WorDate>" + this.missingDisputesModel.wordate + "</WorDate>"
      + "<WfinDate>" + this.missingDisputesModel.wfindate + "</WfinDate>";

    this.workFlowMessageModel.kpiid = this.vkpiid;
    this.workFlowMessageModel.sc_emp_id = "001";
    this.workFlowMessageModel.complanid = this.missingDisputesModel.comm_plan_id;
    this.workFlowMessageModel.sales_rep_id = this.missingDisputesModel.sales_rep_id;

    this.workFlowMessageModel.corp = this.missingDisputesModel.corp;
    this.workFlowMessageModel.house = this.missingDisputesModel.house;
    this.workFlowMessageModel.cust = this.missingDisputesModel.cust_id;
    //this.workFlowMessageModel.message = this.missingDisputesModel.message;
    this.workFlowMessageModel.kom_feed_id = "002";

    this.workFlowMessageModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workFlowMessageModel.employee_id = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');

    this.workFlowMessageModel.message_content = this.disputeMsg + "<Message>" + this.missingDisputesModel.message + "</Message>";

    this.missingDisputesService.insertMissingDispute(formData).subscribe(
      (response: CustomHttpRespone) => {
        this.clickButton('closeAddButton');
        //this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
        this.getMissingDisputes();
        this.insertDispute();
        kpiForm.reset();
        this.vkpiid = "";
        this.missingModels = [];
        this.missingDisputesModel.created_by = "";
        this.missingDisputesModel.created_dt = new Date();
        this.missingModels.push(this.missingDisputesModel);
        this.showLoading = false;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      }
    )
  }

  public insertDispute(): void {

    this.commissionSummaryService.insertDispute(this.workFlowMessageModel).subscribe(
      (response: WorkFlowMessageModel) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully. Ticket Created");
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )

  }

  public clickToCloseButton(buttonId: string, missDisputeForm: NgForm): void {
    document.getElementById(buttonId).click();
    missDisputeForm.reset();
  }

  hideRemainingLabels(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }

  addNewRow(missingForm: NgForm) {
    const kpiObj = new MissingDisputesModel();
    kpiObj.kpi_id = this.missingDisputesModel1.kpi_id;
    kpiObj.comm_plan_id = this.missingDisputesModel1.comm_plan_id;
    this.missingModels.push(kpiObj);
    console.log(this.missingModels);
  }

  public removeRow(index: any) {
    if (this.missingModels.length > 1) {
      if (this.missingModels[index].kpi_id != null) {
        this.removeFilterData(index);
      } else {
        this.removeFilterData(index);
        //this.kpiModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }

  private removeFilterData(i: any) {

    if (this.missingModels.length > 0) {
      const compos = this.missingModels[i].kpi_id;
      this.missingModels.forEach((value: any, index: any) => {
        if (value.kpi_id == compos)
          this.missingModels.splice(index, 1);
      })
    }
    console.log(this.missingModels);
  }

  public onEditMissingDisputes(missingDisputesModel: MissingDisputesModel): void {

  }

  actionOnButton(action: any) {
    if (action === "Add") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    }
  }

  private clickButton(buttonId: string): void {
    console.log(buttonId);
    document.getElementById(buttonId).click();
  }

  innerRowAction1(row: any) {
    console.log("row = " + JSON.stringify(row.row));
    if (row.value === 'Update') {
      this.onEditMissingDisputes(row.row);
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns1 = this.columnsData.MissingDisputesData;
        console.log(this.ordersTableColumns1);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });

    this.actions = []

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-default btn-xs'
      }
    ]

  }


}
